import { createAction, props } from '@ngrx/store';
import { DiscountData } from './nearby.state';

export const loadDiscount = createAction(
  '[Nearby] Load Discount',
  props<{ filter: any }>()
);

export const loadDiscountSuccess = createAction(
  '[Nearby] Load Discount Success',
  props<{ discountData: DiscountData }>()
);

export const loadDiscountFailure = createAction(
  '[Nearby] Load Discount Failure',
  props<{ error: { message: string; statusCode: number } }>()
);

